import axios from "axios";
import AuthAPI from "./auth";
import UserAPI from "./user";
import BusinessAPI from "./business";
import config from "../config";

export class API {
  #baseUrl;
  #client;

  auth;
  user;
  business;

  constructor(baseUrl = config.apiUrl) {
    this.#baseUrl = baseUrl;
    this.#client = axios.create({
      baseURL: this.#baseUrl,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        // "Access-Control-Allow-Origin": "*",
      },
      timeout: 60000,
    });

    this.auth = new AuthAPI(this.#client);
    this.user = new UserAPI(this.#client, this.auth);
    this.business = new BusinessAPI(this.#client, this.auth);
  }
}
const sefaultApi = new API();
// eslint-disable-next-line import/no-anonymous-default-export
export default sefaultApi;
